export {default as axisticks} from './src/AxisTicks';
export {default as datajoin} from './src/DataJoin';
export {default as encode} from './src/Encode';
export {default as legendentries} from './src/LegendEntries';
export {default as linkpath} from './src/LinkPath';
export {default as pie} from './src/Pie';
export {default as scale} from './src/Scale';
export {default as sortitems} from './src/SortItems';
export {default as stack} from './src/Stack';
export {validTicks} from './src/ticks';



// WEBPACK FOOTER //
// ./~/vega-encode/index.js